import type { PostPurchaseSurveyParamsDataModel } from "../models/types";

export const createPostPurchaseSurveyParamsModel = (
  surveyParams?: PostPurchaseSurveyParamsDataModel,
) => {
  if (!surveyParams) {
    return;
  }

  return {
    ...surveyParams,
    findOrderProductBySku: (sku: string) => {
      return surveyParams.orderProducts.find((product) => {
        return product.sku === sku;
      });
    },
  };
};
